import React, { Component } from "react";
import IdleTimer from "react-idle-timer";
import { LOCAL_STORAGE_KEYS } from "../../config/constants";
import { removeFromLocal } from "../../utils/Cache";

export default class IdleTimeWrapper extends Component {
  idleTimer: any;
  constructor(props: any) {
    super(props);
    this.idleTimer = null;
  }

  handleOnIdle = (event: any) => {
    if (window.location.href.includes("login")) {
      this.idleTimer.reset();
    } else {
      removeFromLocal(LOCAL_STORAGE_KEYS.auth);
      setTimeout(() => {
        window.location.reload();
      }, 200);
    }
  };

  render() {
    return (
      <div>
        <IdleTimer
          ref={(ref: any) => {
            this.idleTimer = ref;
          }}
          timeout={120 * 60 * 1000} // 2 hours idle time
          // onActive={this.handleOnActive}
          onIdle={this.handleOnIdle}
          // onAction={this.handleOnAction}
          debounce={250}
        />
        {this.props.children}
      </div>
    );
  }
}
